import { WithLayout } from "PFApp/routes/route_helpers";
import { admin } from "PFCore/base/page_layouts";
import { SkillsFrameworksEditController } from "PFModules/admin/skills_frameworks/edit";
import { SkillsFrameworksListPageController } from "PFModules/admin/skills_frameworks/list/skills_frameworks_list_page_controller";
import { SkillsFrameworkRanks } from "PFTypes";
import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import NotFoundRoute from "../not_found_route";

export const SkillsFrameworksRoutes = () => {
  const { path } = useRouteMatch();

  const availableTabsParam = `(${SkillsFrameworkRanks.join("|")})`;

  return (
    <WithLayout layout={{ sidebar: admin }}>
      <Switch>
        <Route exact path={`${path}/new/:tab${availableTabsParam}?`}>
          <SkillsFrameworksEditController isNew />
        </Route>
        <Route exact path={`${path}/:id/edit`}>
          <SkillsFrameworksEditController />
        </Route>
        <Route exact path={`${path}/:tab${availableTabsParam}`}>
          <SkillsFrameworksListPageController />
        </Route>
        <Route exact path={`${path}/`}>
          <Redirect to={`${path}/primary`} />
        </Route>
        <Route path="*">
          <NotFoundRoute />
        </Route>
      </Switch>
    </WithLayout>
  );
};
